import { Fragment } from 'react';

import { Body1 } from 'ui/theme/typography';
import { UpdatedGoalCriteria } from './UpdatedGoalCriteria';
import { StatusPageGoalCriteriaProps } from '../types';
import { GoalCriteriaDivider, GoalCriteriaHeader, GoalDetailCriteriaSection } from './Styled';
import { GOAL_CRITERIA, TEST_IDS } from '../constants';

const PREDICT_WITH_DURATION_CP = 'Predict likelihood of users in a 30 day period to...';

export const StatusPageGoalCriteria = ({ goal }: StatusPageGoalCriteriaProps) => {
  const predictionHeaderText = PREDICT_WITH_DURATION_CP;
  return (
    <Fragment>
      <GoalCriteriaHeader data-test={TEST_IDS.StatusPageGoalCriteriaHeader}>
        {GOAL_CRITERIA}
      </GoalCriteriaHeader>
      <GoalDetailCriteriaSection>
        <Body1>{predictionHeaderText}</Body1>
        <GoalCriteriaDivider />
        <UpdatedGoalCriteria goal={goal} />
      </GoalDetailCriteriaSection>
    </Fragment>
  );
};
